import { FC } from 'react';
import { BiErrorCircle } from 'react-icons/bi';
import { StateMessage, StateMessageProps } from './state-message';

export const ErrorState: FC<StateMessageProps> = ({
  icon = BiErrorCircle,
  ...props
}) => {
  return <StateMessage icon={icon} data-testid="error-state" {...props} />;
};
